import React, { useState } from "react";
import { Modal, Col, Row, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import {
  TextField,
  Checkbox,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

import { useShowPassword } from "../../CustomHooks/useShowPassword";
import { countryCode } from "../../Utils/constant";

const ParticipantSignupLayout = ({
  values,
  errors,
  touched,
  handleChange,
  handleSubmit,
  isEmailExistTemp,
  isGuestTemp,
  isInsideRoleTemp,
  setError,
  error,
  listOrganizations,
  showParticipantMergeContentSubmitted,
  setShowParticipantMergeContentAlert,
  showParticipantMergeContentPositive,
  userData,
  handleModelClose,
  handleClickOpen,
  handleCheckBoxChange,
  checked,
}) => {

  const {
    showPassword,
    toggleShowPassword,
    showConPassword,
    toggleShowConPassword,
  } = useShowPassword();

  const [currency, setCurrency] = useState("+1");

  const handleCurrencyChange = event => {
    setCurrency(event.target.value);
  };

  const renderLayout = () => {
    let tempRenderObj = [];

    // Email exist in DB START
    if (isEmailExistTemp === "yes") {
      if (isGuestTemp === "yes") {
        if (isInsideRoleTemp === "no") {
          tempRenderObj.push(
            <>
              <Row>
                <Col md="12">
                  <Form.Group>
                    <Form.Label>
                      <FormattedMessage id="COMPANY_NAME" />
                    </Form.Label>

                    <TextField
                      name="comp_name"
                      fullWidth
                      variant="outlined"
                      value={values.comp_name}
                      error={touched.comp_name && Boolean(errors.comp_name)}
                      helperText={touched.comp_name ? errors.comp_name : ""}
                      onChange={e => {
                        handleChange(e);
                        if (error) setError(null);
                      }}
                      onBlur={listOrganizations}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>
                      <FormattedMessage id="AUTH.INPUT.PASSWORD" />
                    </Form.Label>
                    <TextField
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={toggleShowPassword} edge="end">
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      type={showPassword ? "text" : "password"}
                      name="password"
                      autoComplete="new-password"
                      fullWidth
                      variant="outlined"
                      value={values.password}
                      error={touched.password && Boolean(errors.password)}
                      helperText={touched.password ? errors.password : ""}
                      onChange={e => {
                        handleChange(e);
                        if (error) setError(null);
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>
                      <FormattedMessage id="AUTH.INPUT.CONFIRM_PASSWORD" />
                    </Form.Label>
                    <TextField
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={toggleShowConPassword} edge="end">
                              {showConPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      type={showConPassword ? "text" : "password"}
                      name="changepassword"
                      fullWidth
                      variant="outlined"
                      value={values.changepassword}
                      error={
                        touched.changepassword && Boolean(errors.changepassword)
                      }
                      helperText={
                        touched.changepassword ? errors.changepassword : ""
                      }
                      onChange={e => {
                        handleChange(e);
                        if (error) setError(null);
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </>,
          );
        } else {
          if (!showParticipantMergeContentSubmitted) {
            // show alert to merge Data
            setShowParticipantMergeContentAlert(true);
          } else {
            if (showParticipantMergeContentPositive) {
              tempRenderObj.push(
                <>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>
                          <FormattedMessage id="AUTH.INPUT.PASSWORD" />
                        </Form.Label>
                        <TextField
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={toggleShowPassword} edge="end">
                                  {showPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          type={showPassword ? "text" : "password"}
                          name="password"
                          autoComplete="new-password"
                          fullWidth
                          variant="outlined"
                          value={values.password}
                          error={touched.password && Boolean(errors.password)}
                          helperText={touched.password ? errors.password : ""}
                          onChange={e => {
                            handleChange(e);
                            if (error) setError(null);
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>
                          <FormattedMessage id="AUTH.INPUT.CONFIRM_PASSWORD" />
                        </Form.Label>
                        <TextField
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={toggleShowConPassword}
                                  edge="end"
                                >
                                  {showConPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          type={showConPassword ? "text" : "password"}
                          name="changepassword"
                          fullWidth
                          variant="outlined"
                          value={values.changepassword}
                          error={
                            touched.changepassword &&
                            Boolean(errors.changepassword)
                          }
                          helperText={
                            touched.changepassword ? errors.changepassword : ""
                          }
                          onChange={e => {
                            handleChange(e);
                            if (error) setError(null);
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </>,
              );
            } else {
              tempRenderObj.push(
                <>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <Form.Label>
                          <FormattedMessage id="COMPANY_NAME" />
                        </Form.Label>

                        <TextField
                          name="comp_name"
                          fullWidth
                          variant="outlined"
                          value={values.comp_name}
                          error={touched.comp_name && Boolean(errors.comp_name)}
                          helperText={touched.comp_name ? errors.comp_name : ""}
                          onChange={e => {
                            handleChange(e);
                            if (error) setError(null);
                          }}
                          onBlur={listOrganizations}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>
                          <FormattedMessage id="AUTH.INPUT.PASSWORD" />
                        </Form.Label>
                        <TextField
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={toggleShowPassword} edge="end">
                                  {showPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          type={showPassword ? "text" : "password"}
                          name="password"
                          autoComplete="new-password"
                          fullWidth
                          variant="outlined"
                          value={values.password}
                          error={touched.password && Boolean(errors.password)}
                          helperText={touched.password ? errors.password : ""}
                          onChange={e => {
                            handleChange(e);
                            if (error) setError(null);
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>
                          <FormattedMessage id="AUTH.INPUT.CONFIRM_PASSWORD" />
                        </Form.Label>
                        <TextField
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={toggleShowConPassword}
                                  edge="end"
                                >
                                  {showConPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          type={showConPassword ? "text" : "password"}
                          name="changepassword"
                          fullWidth
                          variant="outlined"
                          value={values.changepassword}
                          error={
                            touched.changepassword &&
                            Boolean(errors.changepassword)
                          }
                          helperText={
                            touched.changepassword ? errors.changepassword : ""
                          }
                          onChange={e => {
                            handleChange(e);
                            if (error) setError(null);
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </>,
              );
            }
          }
        }
      } else {
        if (isGuestTemp === "yes") {
          tempRenderObj.push(
            <>
              <Row>
                <Col md="12">
                  <Form.Group>
                    <Form.Label>
                      <FormattedMessage id="COMPANY_NAME" />
                    </Form.Label>

                    <TextField
                      name="comp_name"
                      fullWidth
                      variant="outlined"
                      value={values.comp_name}
                      error={touched.comp_name && Boolean(errors.comp_name)}
                      helperText={touched.comp_name ? errors.comp_name : ""}
                      onChange={e => {
                        handleChange(e);
                        if (error) setError(null);
                      }}
                      onBlur={listOrganizations}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>
                      <FormattedMessage id="AUTH.INPUT.PASSWORD" />
                    </Form.Label>
                    <TextField
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={toggleShowPassword} edge="end">
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      type={showPassword ? "text" : "password"}
                      name="password"
                      autoComplete="new-password"
                      fullWidth
                      variant="outlined"
                      value={values.password}
                      error={touched.password && Boolean(errors.password)}
                      helperText={touched.password ? errors.password : ""}
                      onChange={e => {
                        handleChange(e);
                        if (error) setError(null);
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>
                      <FormattedMessage id="AUTH.INPUT.CONFIRM_PASSWORD" />
                    </Form.Label>
                    <TextField
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={toggleShowConPassword} edge="end">
                              {showConPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      type={showConPassword ? "text" : "password"}
                      name="changepassword"
                      fullWidth
                      variant="outlined"
                      value={values.changepassword}
                      error={
                        touched.changepassword && Boolean(errors.changepassword)
                      }
                      helperText={
                        touched.changepassword ? errors.changepassword : ""
                      }
                      onChange={e => {
                        handleChange(e);
                        if (error) setError(null);
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </>,
          );
        } else {
          tempRenderObj.push(
            <>
              <Row>
                <Col md="12">
                  <Form.Group>
                    <Form.Label>
                      <FormattedMessage id="USER.FULL_NAME" />
                    </Form.Label>
                    <TextField
                      name="name"
                      fullWidth
                      variant="outlined"
                      value={values.name}
                      disabled={userData ? true : false}
                      error={touched.name && Boolean(errors.name)}
                      helperText={touched.name ? errors.name : ""}
                      onChange={e => {
                        handleChange(e);
                        if (error) setError(null);
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <Form.Group>
                    <Form.Label>
                      <FormattedMessage id="AUTH.EMAIL" />
                    </Form.Label>
                    <TextField
                      name="email"
                      fullWidth
                      variant="outlined"
                      value={values.email}
                      disabled={userData ? true : false}
                      error={touched.email && Boolean(errors.email)}
                      helperText={touched.email ? errors.email : ""}
                      onChange={e => {
                        handleChange(e);
                        if (error) setError(null);
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <Form.Group>
                    <Form.Label>
                      <FormattedMessage id="GLOBAL.MOBILE" />
                    </Form.Label>
                    <div className="selectAndInputField countryCodeField">
                      <TextField
                        id="standard-select-selling-currency"
                        select
                        value={currency}
                        onChange={handleCurrencyChange}
                        SelectProps={{
                          native: true,
                        }}
                      >
                        {countryCode.map(option => (
                          <option key={option.label} value={option.label}>
                            {option.label}
                          </option>
                        ))}
                      </TextField>
                      <TextField
                        name="phone"
                        placeholder="###-###-####"
                        fullWidth
                        variant="outlined"
                        value={values.phone}
                        error={touched.phone && Boolean(errors.phone)}
                        helperText={touched.phone ? errors.phone : ""}
                        onChange={e => {
                          handleChange(e);
                          if (error) setError(null);
                        }}
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="12">
                  <Form.Group>
                    <Form.Label>
                      <FormattedMessage id="COMPANY_NAME" />
                    </Form.Label>

                    <TextField
                      name="comp_name"
                      fullWidth
                      variant="outlined"
                      value={values.comp_name}
                      error={touched.comp_name && Boolean(errors.comp_name)}
                      helperText={touched.comp_name ? errors.comp_name : ""}
                      onChange={e => {
                        handleChange(e);
                        if (error) setError(null);
                      }}
                      onBlur={listOrganizations}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>
                      <FormattedMessage id="AUTH.INPUT.PASSWORD" />
                    </Form.Label>
                    <TextField
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={toggleShowPassword} edge="end">
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      type={showPassword ? "text" : "password"}
                      name="password"
                      autoComplete="new-password"
                      fullWidth
                      variant="outlined"
                      value={values.password}
                      error={touched.password && Boolean(errors.password)}
                      helperText={touched.password ? errors.password : ""}
                      onChange={e => {
                        handleChange(e);
                        if (error) setError(null);
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>
                      <FormattedMessage id="AUTH.INPUT.CONFIRM_PASSWORD" />
                    </Form.Label>
                    <TextField
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={toggleShowConPassword} edge="end">
                              {showConPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      type={showConPassword ? "text" : "password"}
                      name="changepassword"
                      fullWidth
                      variant="outlined"
                      value={values.changepassword}
                      error={
                        touched.changepassword && Boolean(errors.changepassword)
                      }
                      helperText={
                        touched.changepassword ? errors.changepassword : ""
                      }
                      onChange={e => {
                        handleChange(e);
                        if (error) setError(null);
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </>,
          );
        }
      }
      // Email exist in DB END
    } else {
      // Email is not exist in DB START
      if (isInsideRoleTemp === "yes") {
        tempRenderObj.push(
          <>
            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>
                    <FormattedMessage id="USER.FULL_NAME" />
                  </Form.Label>
                  <TextField
                    name="name"
                    fullWidth
                    variant="outlined"
                    value={values.name}
                    disabled={userData ? true : false}
                    error={touched.name && Boolean(errors.name)}
                    helperText={touched.name ? errors.name : ""}
                    onChange={e => {
                      handleChange(e);
                      if (error) setError(null);
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>
                    <FormattedMessage id="AUTH.EMAIL" />
                  </Form.Label>
                  <TextField
                    name="email"
                    fullWidth
                    variant="outlined"
                    value={values.email}
                    disabled={userData ? true : false}
                    error={touched.email && Boolean(errors.email)}
                    helperText={touched.email ? errors.email : ""}
                    onChange={e => {
                      handleChange(e);
                      if (error) setError(null);
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>
                    <FormattedMessage id="GLOBAL.MOBILE" />
                  </Form.Label>
                  <div className="selectAndInputField countryCodeField">
                    <TextField
                      id="standard-select-selling-currency"
                      select
                      value={currency}
                      onChange={handleCurrencyChange}
                      SelectProps={{
                        native: true,
                      }}
                    >
                      {countryCode.map(option => (
                        <option key={option.label} value={option.label}>
                          {option.label}
                        </option>
                      ))}
                    </TextField>
                    <TextField
                      name="phone"
                      placeholder="###-###-####"
                      fullWidth
                      variant="outlined"
                      value={values.phone}
                      error={touched.phone && Boolean(errors.phone)}
                      helperText={touched.phone ? errors.phone : ""}
                      onChange={e => {
                        handleChange(e);
                        if (error) setError(null);
                      }}
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Form.Group>
                  <Form.Label>
                    <FormattedMessage id="AUTH.INPUT.PASSWORD" />
                  </Form.Label>
                  <TextField
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={toggleShowPassword} edge="end">
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    type={showPassword ? "text" : "password"}
                    name="password"
                    autoComplete="new-password"
                    fullWidth
                    variant="outlined"
                    value={values.password}
                    error={touched.password && Boolean(errors.password)}
                    helperText={touched.password ? errors.password : ""}
                    onChange={e => {
                      handleChange(e);
                      if (error) setError(null);
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>
                    <FormattedMessage id="AUTH.INPUT.CONFIRM_PASSWORD" />
                  </Form.Label>
                  <TextField
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={toggleShowConPassword} edge="end">
                            {showConPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    type={showConPassword ? "text" : "password"}
                    name="changepassword"
                    fullWidth
                    variant="outlined"
                    value={values.changepassword}
                    error={
                      touched.changepassword && Boolean(errors.changepassword)
                    }
                    helperText={
                      touched.changepassword ? errors.changepassword : ""
                    }
                    onChange={e => {
                      handleChange(e);
                      if (error) setError(null);
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
          </>,
        );
      } else {
        tempRenderObj.push(
          <>
            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>
                    <FormattedMessage id="USER.FULL_NAME" />
                  </Form.Label>
                  <TextField
                    name="name"
                    fullWidth
                    variant="outlined"
                    value={values.name}
                    disabled={userData ? true : false}
                    error={touched.name && Boolean(errors.name)}
                    helperText={touched.name ? errors.name : ""}
                    onChange={e => {
                      handleChange(e);
                      if (error) setError(null);
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>
                    <FormattedMessage id="AUTH.EMAIL" />
                  </Form.Label>
                  <TextField
                    name="email"
                    fullWidth
                    variant="outlined"
                    value={values.email}
                    disabled={userData ? true : false}
                    error={touched.email && Boolean(errors.email)}
                    helperText={touched.email ? errors.email : ""}
                    onChange={e => {
                      handleChange(e);
                      if (error) setError(null);
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>
                    <FormattedMessage id="GLOBAL.MOBILE" />
                  </Form.Label>
                  <div className="selectAndInputField countryCodeField">
                    <TextField
                      id="standard-select-selling-currency"
                      select
                      value={currency}
                      onChange={handleCurrencyChange}
                      SelectProps={{
                        native: true,
                      }}
                    >
                      {countryCode.map(option => (
                        <option key={option.label} value={option.label}>
                          {option.label}
                        </option>
                      ))}
                    </TextField>
                    <TextField
                      name="phone"
                      placeholder="###-###-####"
                      fullWidth
                      variant="outlined"
                      value={values.phone}
                      error={touched.phone && Boolean(errors.phone)}
                      helperText={touched.phone ? errors.phone : ""}
                      onChange={e => {
                        handleChange(e);
                        if (error) setError(null);
                      }}
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>
                    <FormattedMessage id="COMPANY_NAME" />
                  </Form.Label>

                  <TextField
                    name="comp_name"
                    fullWidth
                    variant="outlined"
                    value={values.comp_name}
                    error={touched.comp_name && Boolean(errors.comp_name)}
                    helperText={touched.comp_name ? errors.comp_name : ""}
                    onChange={e => {
                      handleChange(e);
                      if (error) setError(null);
                    }}
                    onBlur={listOrganizations}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Form.Group>
                  <Form.Label>
                    <FormattedMessage id="AUTH.INPUT.PASSWORD" />
                  </Form.Label>
                  <TextField
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={toggleShowPassword} edge="end">
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    type={showPassword ? "text" : "password"}
                    name="password"
                    autoComplete="new-password"
                    fullWidth
                    variant="outlined"
                    value={values.password}
                    error={touched.password && Boolean(errors.password)}
                    helperText={touched.password ? errors.password : ""}
                    onChange={e => {
                      handleChange(e);
                      if (error) setError(null);
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>
                    <FormattedMessage id="AUTH.INPUT.CONFIRM_PASSWORD" />
                  </Form.Label>
                  <TextField
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={toggleShowConPassword} edge="end">
                            {showConPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    type={showConPassword ? "text" : "password"}
                    name="changepassword"
                    fullWidth
                    variant="outlined"
                    value={values.changepassword}
                    error={
                      touched.changepassword && Boolean(errors.changepassword)
                    }
                    helperText={
                      touched.changepassword ? errors.changepassword : ""
                    }
                    onChange={e => {
                      handleChange(e);
                      if (error) setError(null);
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
          </>,
        );
      }
      // Email is not exist in DB END
    }

    tempRenderObj.push(
      <>
        <Row>
          <Col md="12">
            <Form.Group className="termsCheckBox">
              <Checkbox
                checked={checked}
                onChange={handleCheckBoxChange}
                inputProps={{
                  "aria-label": "primary checkbox",
                }}
              />
              <span onClick={handleClickOpen}>
                I understand that by submitting any offers, I agree to
                purchasing the asset, if offer is accepted, and agree to all
                <u> terms and conditions.</u>
              </span>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md="12" className="customModalFooter mb-5">
            <Modal.Footer>
              <button
                type="submit"
                onClick={handleSubmit}
                className="btn btn-primary btn-elevate"
              >
                Submit
              </button>

              <button
                type="button"
                onClick={handleModelClose}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
            </Modal.Footer>
          </Col>
        </Row>
      </>,
    );

    return tempRenderObj;
  };

  return <>{renderLayout()}</>;
};

export default ParticipantSignupLayout;
